<template>
<span>
  <p><span style="font-size:10pt">Inhalt der Leistung:</span></p>

  <ul>
  <li>
    <p><span style="font-size:10pt">Aufnahme von Bestandsobjekt mithilfe eines Laserscanners</span></p>
  </li>
  <li>
    <p><span style="font-size:10pt">Aufbereitung der Daten zu einer 3d-Punktewolke</span></p>
  </li>
  <li>
    <p><span style="font-size:10pt">Bereitstellung der fertigen Punkte</span></p>
  </li>
  </ul>

  <p><span style="font-size:9pt"><em>Hinweis: Das Modell wird als Grundlage f&uuml;r die Planung der notwendigen Blitzschutzma&szlig;nahmen verwendet.</em></span></p>
</span>
</template>

<script>
export default {
  name: "Tooltip3DLaserscanning"
}
</script>

<style scoped>

</style>
